// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"397":"fe79a2d4","571":"fe79a2d4"}[chunkId] + ".chunk.css";
};